export default "/profile/images/Sitniks.svg?ac7d677ce18a754df6b961c5e55ee1c7";